module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/units-or-sublots/units-or-sublots.component.css
// module id = ./src/app/units-or-sublots/units-or-sublots.component.css
// module chunks = main